export const reportFormatEnum = {
  PDF: 1,
  Excel: 2,
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/ReportFormatEnum.js